import "../../styles/style.css";
import Text from "../Text";

const Header = () => {
    return (
		<header className="header">
			<div className="header-wrapper">
				<h1 className="header-title">
					<strong>
						<span className='wave'>👋 </span>Hello, I'm <em>Alex</em>
					</strong>
					<Text /><strong>developer</strong>
				</h1>
				<a href="https://drive.google.com/file/d/11N1tYl0YUpNYo9m7xcRGUAVTqmmCv4At/view?usp=sharing" className="btn">
					Download CV
				</a>
			</div>
		</header>
	);
}

export default Header;